module.exports = __webpack_public_path__ + "static/logo-73d542ae8d547d9e2849b44a886e573f.svg";